import { gql } from 'apollo-angular';

export const controlListQuery = gql`
  query ControlList {
    controlList {
      id
      status
      device {
        id
        name
      }
      category {
        id
        name
      }
      groups {
        id
        name
      }
      isActive
      action {
        id
        type
        measure
        min
        max
        value
      }
    }
  }
`;

export const toggleONOFFCtrlMutation = gql`
  mutation ToggleONOFFCtrl($id: ID!, $isActive: Boolean!) {
    toggleONOFFCtrl(id: $id, isActive: $isActive) {
      id
      isActive
    }
  }
`;

export const updateActionCtrlValueMutation = gql`
  mutation UpdateActionCtrlValue($id: ID!, $value: Float!) {
    updateActionCtrlValue(id: $id, value: $value) {
      id
      value
    }
  }
`;
